import _styled from "styled-components";
import * as React from 'react';
import { useMemo } from 'react';
import isUrlHttp from 'is-url-http';
import { listIconMap } from '@restworld/utils-common';
import { Title, colorMap, sizeMap } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SecondaryList = function SecondaryList(_ref) {
  var itemList = _ref.itemList,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
      fontSize = _ref.fontSize,
      textColor = _ref.textColor,
      _ref$isWrapList = _ref.isWrapList,
      isWrapList = _ref$isWrapList === void 0 ? true : _ref$isWrapList;
  var listElement = useMemo(function () {
    return getListElement({
      fontSize: fontSize,
      textColor: textColor,
      itemList: itemList
    });
  }, [fontSize, itemList, textColor]);
  return /*#__PURE__*/_jsx(Wrapper, {
    isWrapList: isWrapList,
    orientation: orientation,
    children: listElement
  });
};
export default SecondaryList; // --> styled components

var Wrapper = /*#__PURE__*/_styled.ul.withConfig({
  displayName: "listsecondary__Wrapper",
  componentId: "sc-12c88jo-0"
})(["", ";", " ", ""], {
  "@media (min-width: 768px)": {
    "height": "100%",
    "maxHeight": "15rem"
  }
}, function (_ref2) {
  var orientation = _ref2.orientation;
  return orientation === 'vertical' ? {
    "display": "flex",
    "flexDirection": "column",
    "columnGap": "0.5rem"
  } : {
    "display": "flex",
    "justifyContent": "center",
    "columnGap": "0.75rem",
    "alignSelf": "center"
  };
}, function (_ref3) {
  var isWrapList = _ref3.isWrapList,
      orientation = _ref3.orientation;
  return isWrapList ? orientation === 'vertical' ? {
    "flexWrap": "wrap"
  } : {
    "flexWrap": "wrap-reverse"
  } : {};
});

var getListElement = function getListElement(_ref4) {
  var itemList = _ref4.itemList,
      fontSize = _ref4.fontSize,
      textColor = _ref4.textColor;
  return itemList === null || itemList === void 0 ? void 0 : itemList.map(function (_ref5) {
    var label = _ref5.label,
        icon = _ref5.icon,
        key = _ref5.key;
    var iconEl = icon ? Object.keys(listIconMap).includes(icon) ? listIconMap[icon] : isUrlHttp(icon) && /*#__PURE__*/_jsx(Image, {
      src: icon,
      alt: ""
    }) : '';
    return /*#__PURE__*/_jsxs(ListWrapper, {
      fontSize: fontSize,
      textColor: textColor,
      children: [iconEl ? /*#__PURE__*/_jsx(Icon, {
        children: iconEl
      }) : '', /*#__PURE__*/_jsx(Title, {
        content: label,
        textColor: textColor,
        fontWeight: "light"
      })]
    }, key);
  });
};

var ListWrapper = /*#__PURE__*/_styled.li.withConfig({
  displayName: "listsecondary__ListWrapper",
  componentId: "sc-12c88jo-1"
})(["", " ", " ", ""], {
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem",
  "paddingBottom": "0.5rem",
  "fontWeight": "400"
}, function (_ref6) {
  var _ref6$textColor = _ref6.textColor,
      textColor = _ref6$textColor === void 0 ? 'white' : _ref6$textColor;
  return colorMap[textColor];
}, function (_ref7) {
  var _ref7$fontSize = _ref7.fontSize,
      fontSize = _ref7$fontSize === void 0 ? 'base' : _ref7$fontSize;
  return sizeMap[fontSize];
});

var Icon = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listsecondary__Icon",
  componentId: "sc-12c88jo-2"
})({
  "flexShrink": "0"
});

var Image = /*#__PURE__*/_styled.img.withConfig({
  displayName: "listsecondary__Image",
  componentId: "sc-12c88jo-3"
})({
  "height": "1.25rem",
  "width": "1.25rem"
}); // --> types